import * as React from 'react';
import { List, Datagrid, TextField, EditButton, TextInput, FunctionField } from 'react-admin';
import useAuthorize from '../hooks/useAuthorize';
import { UserRole } from '../types/types';

const UserFilter = [
    <TextInput label="User" source="user_search" resettable alwaysOn/>,
];

export const UserList = (props: any) => {
    useAuthorize([UserRole.Admin, UserRole.ProductAdmin]);
    
    return (
        <List 
            filters={UserFilter} 
            {...props}
            sort={{ field: 'company_name', order: 'ASC' }}
            perPage={25}
        >
            <Datagrid bulkActionButtons={false} rowStyle={(record) => record?.active === false ? { backgroundColor: '#e8e8e8' } : {}}>
                <TextField source="company_name" label="Company Name" />
                <TextField source="user_name" label="User Name" />
                <TextField source="user_first_name" label="First Name" />
                <TextField source="user_last_name" label="Last Name" />
                <TextField source="email_address" label="Email" />
                <TextField source="phone_mobile" label="Mobile" />
                <FunctionField
                    label="GSTs"
                    render={(record: { role_id?: number | string; gst_count?: number }) => {
                        if (Number(record?.role_id) !== UserRole.Seller) return '—';
                        const count = Number(record?.gst_count ?? 0);
                        return count === 0 ? '0' : String(count);
                    }}
                />
                <FunctionField
                    label="Seller type"
                    render={(record: { role_id?: number | string; seller_category?: string }) => {
                        if (Number(record?.role_id) !== UserRole.Seller) return '—';
                        const v = record.seller_category || 'seller';
                        if (v === 'marketplace') return 'Marketplace';
                        if (v === 'reseller') return 'Reseller';
                        if (v === 'recycle') return 'Recycle';
                        return 'Seller';
                    }}
                />
                <EditButton />
            </Datagrid>
        </List>
    );
};

export default UserList;